<app-ariane-nav [label]="arianeLabel" [icon]="arianeIcon" [arianeList]="this.arianeList"></app-ariane-nav>
<mat-divider class="my-3"></mat-divider>
<div class="filter-container">
  <mat-form-field class="mt-20 col-xs-12 field-filtre">
    <mat-label>Filter</mat-label>
    <input matInput #filterInput [formControl]="filterGenerique" />

    @if (filterGenerique.value) {
      <button mat-icon-button matSuffix aria-label="Effacer le filtre" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>

  <div class="col flex-container end align-items-center"></div>
</div>
<div class="optimzed mt-3">
  <app-data-table-optimized
    #administrationTable
    [displayedColumns]="demandesDisplayedColumns"
    [getData]="loadListServices"
    [externalFilter$]="filterSubject"
    [cellStyleCss]="demandesCellStyleCss"
    [hasView]="false"
    [hasPagination]="true"
    [selectable]="false"
    [editable]="true"
    [renewable]="false"
    [deletable]="false"
    [downloadable]="false"
    [downloadablePJ]="false"
    [downloadablePJ_hidden]="false"
    (editItemEvent)="editService($event)"
    >
  </app-data-table-optimized>
</div>
